import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ClosePermitModal = ({ permit, onClose, onConfirm }) => {
  const [closeReason, setCloseReason] = useState('');

  const handleSubmit = (e) => {
    e?.preventDefault();
    onConfirm(permit?.id, closeReason);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card border border-border rounded-lg shadow-xl max-w-md w-full">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
              <Icon name="XCircle" size={20} className="text-red-600 dark:text-red-400" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-foreground">Close Permit</h2>
              <p className="text-sm text-muted-foreground">{permit?.permitId}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-muted rounded transition-colors"
            aria-label="Close modal"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="bg-muted/50 rounded-lg p-4 space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Work Description:</span>
              <span className="font-medium text-foreground text-right">{permit?.workDescription}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Location:</span>
              <span className="font-medium text-foreground">{permit?.location}</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-muted-foreground">Assigned To:</span>
              <span className="font-medium text-foreground">{permit?.assignedTo}</span>
            </div>
          </div>

          <div className="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4">
            <div className="flex gap-3">
              <Icon name="AlertTriangle" size={20} className="text-amber-600 dark:text-amber-400 flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-amber-900 dark:text-amber-200 mb-1">
                  Confirm Permit Closure
                </p>
                <p className="text-xs text-amber-800 dark:text-amber-300">
                  This action will permanently close the permit. Ensure all work is completed and safety protocols are followed.
                </p>
              </div>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Closure Notes <span className="text-red-500">*</span>
            </label>
            <textarea
              required
              value={closeReason}
              onChange={(e) => setCloseReason(e?.target?.value)}
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 resize-none"
              rows="4"
              placeholder="Provide closure notes and confirmation that work is completed..."
            />
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="destructive"
              iconName="Check"
              className="flex-1"
            >
              Close Permit
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ClosePermitModal;